import { FC } from "react";
import styles from "./product-card-7.module.css";
import HighlightStarBox from "../../components/highlight-star-box";
import WholesaleBox from "../../components/wholesale-box";
import { ProductCardSelector } from "../../../product-card-selector";
import {
  AppLink,
  useProductCardLogic } from
"@commons-monorepo/index";
import { ProductCardProps } from "../../product-card.types";
import KitTag from "../../components/kit-tag";

const ProductCard7: FC<ProductCardProps> = ({
  product,
  withTags,
  cartProducts,
  theme,
  addProduct,
  removeProduct,
  manuallyChangeProduct,
  locale,
  currency,
  ComponentLinks
}) => {
  const {
    hasDiscount,
    images,
    percentageDiscount,
    isWholesale,
    isHighlight,
    isKit,
    finalPrice,
    formattedFinalPrice,
    formattedWithoutDiscountPrice,
    urlProductDetail
  } = useProductCardLogic({ product, locale, currency });

  return (
    <AppLink className={styles.productCard7Wrapper} to={urlProductDetail()} Component={ComponentLinks}>
      <figure className={styles.img}>
        <img
          alt={product?.name}
          loading='lazy'
          src={images[0]?.url}
          className={`${styles.productImage} ${styles.one} ${
          images.length > 1 && styles.animate
          }`} />

        {images.length > 1 &&
        <img
          alt={product?.name}
          loading='lazy'
          src={images[1]?.url}
          className={`${styles.productImage} ${styles.two} ${
          images.length > 1 && styles.animate
          }`} />}


      </figure>
      <div className={styles.info}>
        <div className={styles.name}>{product.name}</div>
        {finalPrice > 0 &&
        <div className={styles.values}>
            {hasDiscount && !isKit &&
          <div className={styles.withoutDiscountPrice}>
                {formattedWithoutDiscountPrice}
              </div>}

            <div className={styles.price}>
              <div className={styles.value}>{formattedFinalPrice}</div>
              {!!percentageDiscount &&
            <div className={styles.discount}>{percentageDiscount}%OFF</div>}

            </div>
            {isKit &&
          <div className={styles.totalUnitsKit}>
                {product.totalUnits || 0} unidades
              </div>}

          </div>}

        <div className={styles.indicators}>
          {isKit && withTags && <KitTag />}
          {isHighlight && withTags &&
          <HighlightStarBox className={styles.highlightStarBox} />}

          {isWholesale && withTags &&
          <WholesaleBox className={styles.wholesaleBox} />}

        </div>
        {finalPrice > 0 &&
        <ProductCardSelector
          className={styles.productSelector}
          product={product}
          cartProducts={cartProducts}
          addProduct={addProduct}
          removeProduct={removeProduct}
          manuallyChangeProduct={manuallyChangeProduct}
          theme={theme} />}


      </div>
    </AppLink>);

};

export default ProductCard7;